var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopSliderArrowNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.687,
    height: 161.375,
    viewBox: "0 0 80.687 161.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(46,45,121,0.17)",
    d: "M80.687 161.375V0a80.687 80.687 0 0 0 0 161.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: "3px",
    d: "M15.857 15.856L0 31.713l15.857-15.857.511.511-.511-.511.511-.511-.511.511L0 0z",
    transform: "translate(37.34 63.938)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopSliderArrowNew);
export default __webpack_public_path__ + "static/media/top-slider-arrow-new.b2de193a649b7bf917e37e69d6ad7588.svg";
export { ForwardRef as ReactComponent };